<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed"></h1>
        </div>
        <div class="controls">
            <div
                (click)="logout()"
                class="fab small"
                id="btn-Exit"
                matTooltip="Uitloggen"
                matTooltipPosition="below">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>

    <div class="customer">
        @if (AuthorisationService.hasFeature('customerAreaGet')) {
            <div>
                <div class="action" matRipple routerLink="/customer-selection">
                    <i class="fas fa-snowplow fa-4x"></i>
                    <span>Onderhoud</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('incidentList')) {
            <div>
                <div class="action" matRipple routerLink="/incident">
                    <i class="fas fa-exclamation-triangle fa-4x"></i>
                    <span>Meldingen</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('listRepairs')) {
            <div>
                <div class="action" matRipple routerLink="/repairs">
                    <i class="fas fa-hammer fa-4x"></i>
                    <span>Reparatie</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('libraryList')) {
            <div>
                <div class="action" matRipple routerLink="/library">
                    <i class="fas fa-book fa-4x"></i>
                    <span>Bibliotheek</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('lrma')) {
            <div>
                <div class="action" matRipple routerLink="/lmra">
                    <i class="fas fa-first-aid fa-4x"></i>
                    <span>LMRA</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('listArticles')) {
            <div>
                <div class="action" matRipple routerLink="/{{Routenames.articles}}">
                    <i class="fas fa-newspaper fa-4x"></i>
                    <span>Nieuws</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasFeature('getPbmRequests')) {
            <div>
                <div class="action" matRipple routerLink="/{{Routenames.ppeRequest}}">
                    <i class="fas fa-hard-hat fa-4x"></i>
                    <span>PBM</span>
                </div>
            </div>
        }

        @if (AuthorisationService.hasFeature('checklistAnswers')) {
            <div>
                <div class="action" matRipple routerLink="/{{Routenames.checklistFillIn}}">
                    <i class="fas fa-clipboard-check fa-4x"></i>
                    <span>Inspectielijsten</span>
                </div>
            </div>
        }

        @if (AuthorisationService.hasFeature('declarations')) {
            <div>
                <div class="action" matRipple routerLink="/{{Routenames.declarationRequest}}">
                    <i class="fas fa-file-invoice fa-4x"></i>
                    <span>Declaraties</span>
                </div>
            </div>
        }

        @if (AuthorisationService.hasFeature('getMoldRequests')) {
            <div>
                <div class="action" matRipple routerLink="/{{Routenames.moldRequest}}">
                    <i class="fas fa-do-not-enter fa-4x"></i>
                    <span>Mallen</span>
                </div>
            </div>
        }

        @if (AuthorisationService.hasFeature('getMoldRequests')) {
            <div>
                <div class="action" matRipple routerLink="/{{Routenames.smallMaterialRequest}}">
                    <i class="fas fa-coffee-pot fa-4x"></i>
                    <span>Klein Materiaal</span>
                </div>
            </div>
        }

        @if (AuthorisationService.hasFeature('userCurrentSave')) {
            <div>
                <div class="action" matRipple routerLink="/profile">
                    <i class="fas fa-user fa-4x"></i>
                    <span>Profiel</span>
                </div>
            </div>
        }
        @if (AuthorisationService.hasAnyFeature(management)) {
            <div>
                <div class="action" matRipple routerLink="/management">
                    <i class="fas fa-tools fa-4x"></i>
                    <span>Beheer</span>
                </div>
            </div>
        }
    </div>
    <div class="version-info">{{cordovaVersion()}}</div>
</div>
